﻿'use strict';

angular.module('ntmApp').factory('RadioButtonChoiceFilter', function () {

    function RadioButtonChoiceFilter(getLabelAction) {

        this.filterItem = null;
        this.displayLabelAction = getLabelAction;

        this.isDefined = function () {
            return this.filterItem;
        };

        this.isPartlyDefined = function () {
            return this.isDefined();
        };

        this.clear = function () {
            this.filterItem = null;
        };

        this.getLabel = function () {

            if (this.displayLabelAction) {
                return this.displayLabelAction(this.filterItem);
            }

            return this.filterItem;
        };
    }

    return (RadioButtonChoiceFilter);
});